export enum CollapsiblePanelCssVars {
  /**
   * The collapsible panel's height.
   * @type {number}
   */
  collapsiblePanelHeight = '--collapsible-panel-height',
  /**
   * The collapsible panel's width.
   * @type {number}
   */
  collapsiblePanelWidth = '--collapsible-panel-width',
}
